import type { ProcessDraftStep } from '@bliks-io/contracts';
import { expandRuleIdToOutputGroup } from '../../graph/expandRuleIdToOutputGroup';

export function ruleIdsForConnect(
  source: ProcessDraftStep | undefined,
  ruleId: string | undefined
): string[] | undefined {
  if (!ruleId) return undefined;
  const expanded = expandRuleIdToOutputGroup(source?.rules, ruleId);
  return expanded.length > 0 ? expanded : [ruleId];
}
